import { render } from "./ExperiencesList.vue?vue&type=template&id=c8f8faf4"
import script from "./ExperiencesList.vue?vue&type=script&lang=js"
export * from "./ExperiencesList.vue?vue&type=script&lang=js"
script.render = render

export default script